import React from 'react'
import ReactDOM from 'react-dom/client'
import OldApp from './App.jsx'
import NewApp from './NewApp.jsx'
import './styles/index.css'

// Toggle between old and new app for development
// Set to true to test the new authentication and household features
const USE_NEW_APP = window.location.search.includes('new=true');

const AppToRender = USE_NEW_APP ? NewApp : OldApp;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppToRender />
  </React.StrictMode>,
)
